import { render, staticRenderFns } from "./Bien.vue?vue&type=template&id=1e4d9dc3"
import script from "./Bien.vue?vue&type=script&lang=js"
export * from "./Bien.vue?vue&type=script&lang=js"
import style0 from "./Bien.vue?vue&type=style&index=0&id=1e4d9dc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QBar,QIcon,QSpace,QBtn,QTooltip,QCardSection,QInput});qInstall(component, 'directives', {ClosePopup});
